export class MindboxTracker {

    constructor() {
        this.defaulIdentityProvider = 'WebsiteBeautyShopId';
    }

    /**
     * Используется для выполнения операции потребителя.
     * @param operationName
     * @param operationData
     * @param successCallback
     * @param errorCallback
     */
    performOperation(operationName, operationData, successCallback, errorCallback)
    {
        const parameters = {
            operation: operationName,
            data: operationData
        };

        if (typeof successCallback === 'function') {
            parameters.success = successCallback;
        }

        if (typeof errorCallback === 'function') {
            parameters.error = errorCallback;
        }

        if (isDevelopment){
            //console.log('performOperation', parameters);
        } else {
            window.directCrm('performOperation', parameters);
        }
    }

    /**
     * Используется для идентификации потребителя.
     * @param operationName
     * @param identificator
     * @param provider
     * @param operationData
     * @param successCallback
     * @param errorCallback
     */
    identify (operationName, identificator, provider, operationData, successCallback, errorCallback) {
        const parameters = {
            operation: operationName,
            identificator: {
                provider: provider ? provider : this.defaulIdentityProvider,
                identity: identificator
            }
        };

        if (operationData) {
            parameters.data = operationData;
        }

        if (typeof successCallback === 'function') {
            parameters.success = successCallback;
        }

        if (typeof errorCallback === 'function') {
            parameters.error = errorCallback;
        }

        if (isDevelopment) {
            //console.log('identify', parameters);
        } else {
            window.directCrm('identify', parameters);
        }
    }

    /**
     * Используется для надежной аутентификации потребителя.
     * @param ticket
     */
    authentificate(ticket) {
        if (isDevelopment) {
            //console.log('authenticate', ticket);
        } else {
            window.directCrm('authenticate', ticket);
        }
    }

    userRegistered(user) {
        this.identify('RegistrationMainForm', user.id, this.defaulIdentityProvider, formatUser(user));
    }

    userAuthorized(user) {
        this.identify('EnterSite', user.id);
    }

    userUpdated(user) {
        this.performOperation('EditPersonal', formatUser(user));
    }

    userChangedSubscription(user) {

        if (user.authorized === true) {
            const userFormatted = formatUser(user);
            this.performOperation('ChangeSubscriptionStatus', {
                subscriptions: userFormatted.subscriptions,
                authenticationTicket: userFormatted.authenticationTicket
            });
        } else {
            this.identify('PopupSubscribe', user.email, 'email')
        }
    }

    orderCreated(order, basket, user) {
        const userData = formatUser(user);

        if (order.is_one_click) {
            this.identify('CreateOrder1Click', userData.mobilePhone, 'mobilePhone', {
                fullName: userData.firstName,
                order: formatOrder(order, basket)
            });
        } else {
            this.performOperation('CreateOrderWithPersonal', {
                name: userData.firstName,
                last_name: userData.lastName,
                email: userData.email,
                mobilePhone: userData.mobilePhone,
                subscriptions: userData.subscriptions,
                authenticationTicket: userData.authenticationTicket,
                order: formatOrder(order, basket)
            });
        }
    }

    basketItemAdded(product) {
        const basketItem = formatBasketItem(product);

        this.performOperation('AddItemToCart', {
            action: {
                productId: basketItem.productId,
                skuId: basketItem.skuId,
                price: basketItem.price
            }
        });
    }

    basketItemUpdated(product) {
        const basketItem = formatBasketItem(product);

        this.performOperation('ChangeItemsCountInCart', {
            action: {
                productId: basketItem.productId,
                skuId: basketItem.skuId,
                price: basketItem.price,
                count: basketItem.quantity
            }
        });
    }

    productPageView(product) {
        this.performOperation('ViewProduct', {
            action: {
                productId: product.product_uid,
                skuId: product.uid
            }
        });
    }

    categoryPageView(category) {
        this.performOperation('ViewCategory', {
            action: {
                productCategoryId: category.id
            }
        });
    }

    productSubscribed(product, user) {
        const userFormatted = formatUser(user);
        this.identify('AddItemToInformList', userFormatted.email, 'email', {
            firstName: userFormatted.firstName,
            action: {
                productId: product.product_uid,
                skuId: product.uid
            }
        });
    }
}

let formatUser = (user) => {
    const userData = {};

    if (user.full_name) {
        userData.fullName = user.full_name;
    } else {
        if (user.name) {
            userData.firstName = user.name;
        }

        if (user.last_name) {
            userData.lastName = user.last_name;
        }

        if (user.second_name) {
            userData.secondName = user.second_name;
        }
    }

    if (user.email) {
        userData.email = user.email;
    }

    if (user.phone) {
        userData.mobilePhone = user.phone;
    }

    if (user.city) {
        userData.settlement = user.city;
    }

    userData.subscriptions = [
        {
            pointOfContact: 'Email',
            topic: 'beautyshop',
            isSubscribed: typeof user.subscribed !== 'undefined' && user.subscribed === true,
            valueByDefault: true
        }
    ];

    if (user.mindbox && user.mindbox.token) {
        userData.authenticationTicket = user.mindbox.token;
    }

    return userData;
};

let formatBasket = (basket) => {
    return basket.map((basketItem) => {
        return formatBasketItem(basketItem);
    });
};

let formatBasketItem = (basketItem) => {
    return {
        skuId: basketItem.uid,
        productId: basketItem.product_uid,
        quantity: parseFloat(basketItem.quantity),
        price: parseFloat(basketItem.price)
    };
};

let formatOrder = (order, basket) => {
    const orderData = {
        webSiteId: order.id,
        price: parseFloat(order.price)
    };

    if (order.mindbox && order.mindbox.delivery_system_id) {
        orderData.deliveryType = order.mindbox.delivery_system_id;
    }

    if (order.mindbox && order.mindbox.payment_system_id) {
        orderData.paymentType = order.mindbox.payment_system_id;
    }

    orderData.items = formatBasket(basket);

    return orderData;
};


// WEBPACK FOOTER //
// ./modules/tracker/mindbox.js